import EventActivityVue from '@/views/sa/event-activity/event-activity.vue';

const basePath = '/sa/event-activity';
const role = 'sa'; // 角色身份

export const SA_EVENT_ACTIVITY_RESERVATION_EDIT = 'sa-event-activity-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/edit`,
  component: EventActivityVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/edit/:id`,
      name: SA_EVENT_ACTIVITY_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/event-activity/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
